import { SimpleError } from '@common/errors';
class DateDecoder {
    decode(data) {
        return new Date(data.integer);
    }
    decodeField(data, _, currentField) {
        if (typeof data === 'number' && Number.isSafeInteger(data)) {
            return new Date(data);
        }
        if (typeof data === 'string') {
            const parsed = Number.parseInt(data);
            if (!isNaN(parsed)) {
                return new Date(parsed);
            }
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected an integer (Date) at ${currentField}`,
            field: currentField,
        });
    }
}
Date.prototype.encode = function (context) {
    return this.getTime();
};
// We export an instance to prevent creating a new instance every time we need to decode a number
export default new DateDecoder();
//# sourceMappingURL=DateDecoder.js.map